export default "__VITE_ASSET__DIWjfU6q__"